import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      class: "charging-stations-svg-fill"
    }, [
      _createElementVNode("g", {
        fill: "currentColor",
        "fill-rule": "nonzero",
        class: "charging-stations-svg-fill"
      }, [
        _createElementVNode("path", {
          d: "M20.485 3.515A11.92 11.92 0 0 0 12 0a11.92 11.92 0 0 0-8.485 3.515A11.92 11.92 0 0 0 0 12c0 3.205 1.248 6.219 3.515 8.485A11.92 11.92 0 0 0 12 24v-1.406c-2.83 0-5.49-1.102-7.49-3.103-2.002-2.001-3.104-4.661-3.104-7.49S2.508 6.51 4.51 4.508C6.51 2.51 9.17 1.406 12 1.406s5.49 1.102 7.491 3.103S22.594 9.17 22.594 12v3.281a4.95 4.95 0 0 1-4.946 4.946 4.95 4.95 0 0 1-4.906-4.322 3.52 3.52 0 0 0 2.774-3.436V8.953H14.11V6.141h-1.407v2.812h-1.406V6.141H9.891v2.812H8.485v3.516a3.52 3.52 0 0 0 2.844 3.45 6.36 6.36 0 0 0 6.32 5.714A6.36 6.36 0 0 0 24 15.28v-3.28c0-3.206-1.248-6.22-3.514-8.486z",
          class: "charging-stations-svg-fill"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }